var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModalCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 1.66667C5.39763 1.66667 1.66667 5.39763 1.66667 10C1.66667 14.6024 5.39763 18.3333 10 18.3333C14.6024 18.3333 18.3333 14.6024 18.3333 10C18.3333 5.39763 14.6024 1.66667 10 1.66667ZM0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10ZM13.0893 6.91074C13.4147 7.23618 13.4147 7.76382 13.0893 8.08926L11.1785 10L13.0893 11.9107C13.4147 12.2362 13.4147 12.7638 13.0893 13.0893C12.7638 13.4147 12.2362 13.4147 11.9107 13.0893L10 11.1785L8.08926 13.0893C7.76382 13.4147 7.23618 13.4147 6.91074 13.0893C6.58531 12.7638 6.58531 12.2362 6.91074 11.9107L8.82149 10L6.91074 8.08926C6.58531 7.76382 6.58531 7.23618 6.91074 6.91074C7.23618 6.58531 7.76382 6.58531 8.08926 6.91074L10 8.82149L11.9107 6.91074C12.2362 6.58531 12.7638 6.58531 13.0893 6.91074Z",
    fill: "#CA2867"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalCloseIcon);
export default __webpack_public_path__ + "static/media/modal-close-icon.cb3b0dfd290912a3b45b0176d5c6b8b8.svg";
export { ForwardRef as ReactComponent };